/* eslint-disable no-unused-vars */
import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { APP_URL, BATCH_SIZE, withCredentials } from '../App';
import {decryptResponse, encryptPayload} from './CryptoUtil';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';



const EnableNotification = () => {
 
  const navigate = useNavigate()
  const [error, setError] = useState('');

  const [fileName, setFileName] = useState('');  
  const [file, setFile] = useState(null);
  const [fileSize, setFileSize] = useState(0);
  const fileInputRef = useRef(null);

  const [csvContent, setCsvContent] = useState('');    
  const [jsonContent, setJsonContent] = useState(null);

  const [incorrectData, setIncorrectData] = useState([]);
  const [correctData, setCorrectData] = useState([]);
  const [correctImeiData, setCorrectImeiData] = useState([]);

  const [downloadUrl, setDownloadUrl] = useState(null);

  const [showDownloadButton, setShowDownloadButton] = useState(false);
 

  const [singleImei, setSingleImei] = useState('');

  const [readingTime, setReadingTime] = useState(0);
  const [processTime,setProcessTime]= useState(0)

  const [pleasWait ,setPleaseWait] = useState(false)
  const [processBatchWait ,setProcessBatchWait] = useState(false)

  

  //pending bulk notify
  const [pendingBulkNotify, setPendingBulkNotify] = useState(false);
  const [lastimei, setLastImei] = useState();
  const [batchfilename, setBatchFileName] = useState();

  //batch Complete
  const [batchComplete, setBatchComplete] = useState(false);


  //autoscrolling
  const tableEndRef = useRef(null);

  //show hide batch upload
  const [newBatch,setNewBatch] = useState(true);

 const [selectedOption, setSelectedOption] = useState('');
 const [customerName, setCustomerName] = useState('');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
 const [message,setMessage]=useState('');
 

 const [previewData, setPreviewData] = useState(null);
 const [showPreviewModal, setShowPreviewModal] = useState(false);
 
  

  useEffect(()=>{

  
   
    const notifyBatchStatus = JSON.parse(localStorage.getItem('notifyBatchStatus'))
   
    try{
     
      if(notifyBatchStatus.isComplete==="incomplete"){
        setNewBatch(false)
        const pendingBulkNotify=true
        setPendingBulkNotify(pendingBulkNotify)        
       
        setLastImei(notifyBatchStatus.lastimei)
        setBatchFileName(notifyBatchStatus.batchfilename)
        updateStatusOnServer(notifyBatchStatus)

      }else{
        setNewBatch(true)
        const pendingBulkNotify=false
        setPendingBulkNotify(pendingBulkNotify)
       
        setLastImei('')
        setBatchFileName('')
        updateStatusOnServer(notifyBatchStatus)

      }
  }catch(error){
     /* continue regardless of error */

  }

  },[])

  useEffect(()=>{
  
    
    if(batchComplete){
      
      const notifyBatchStatus = JSON.parse(localStorage.getItem('notifyBatchStatus'))
      updateStatusOnServer(notifyBatchStatus)
      setPendingBulkNotify(false)
      localStorage.removeItem("notifyBatchStatus")
      localStorage.removeItem("correctedDataNotify")
    }

  },[batchComplete,newBatch])

  const updateStatusOnServer=async(notifyBatchStatus)=>{
   
    try{
      let isComplete= notifyBatchStatus.isComplete;    
      
     
      const response = await axios.post(APP_URL+'updateStatusOnServer.php',
        encryptPayload({'lastimei':notifyBatchStatus.lastimei,
          'fileName':notifyBatchStatus.batchfilename,
          'isComplete':isComplete,
          'statusOf':'notifyfiles',
           'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email
          

        }),
        {withCredentials: withCredentials,
          headers: {
          'Content-Type': 'application/json',
          'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
        }})
     


    }catch(error){
       /* continue regardless of error */
      

    }
  }


 
  const sendRequestToServer = async (number) => {
    
   
    try {

    
      const response = await axios.post(APP_URL+'getimeidetails.php',
       encryptPayload( 
        { "imei":number.imei1,
         "action":"notify",
         "message":number.message,
         "template":number.template,


         "filename":fileName,
         'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email
                  

         }),
         {
          withCredentials: withCredentials,
          headers: {
           'Content-Type': 'application/json',
           'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
         }}
       )

      
       response.data.nmessage=number.message
       response.data.myheader=number.myheader
       response.data.name=number.name
       response.data.amount=number.amount
       response.data.date=number.date
       response.data.template=number.template
       response.data.imei=number.imei1

 
       

      return response.data;
    } catch (error) {
     
      return { "status": "failed","message":"not found"};
    }
  };

  const processBatch = async (numbersBatch) => {
    const results = [];
    for (const number of numbersBatch) {
     
        const result = await sendRequestToServer(number);     
       
        results.push(result);   

     
        if(correctData[correctData.length-1].imei1===number.imei1){
        //   console.log("correctData last IMEI:", correctData[correctData.length - 1]);
        // console.log("Current processing IMEI:", number.imei1);
        // console.log("Comparison result:", correctData[correctData.length - 1].imei1 === number.imei1);
          const notifyBatchStatus ={
            'lastimei':number.imei1,
            'batchfilename':fileName,
            'isComplete':'complete'
          }        
          console.log("notifyBatchStatus:", notifyBatchStatus);
          localStorage.setItem("notifyBatchStatus",JSON.stringify(notifyBatchStatus)) 
         
          const batchComplete=true        
          setBatchComplete(batchComplete)
          const newBatch=true          
          setNewBatch(newBatch)
         

        }else{
         
           
           const notifyBatchStatus ={
            'lastimei':number.imei1,
            'batchfilename':fileName,
            'isComplete':'incomplete'
          } 
         

          localStorage.setItem("notifyBatchStatus",JSON.stringify(notifyBatchStatus))
         
         

        }
       
       
       
     
    }
    return results;
  };
 
  const processAllNumbers = async (numbers) => {

    const startTimeProcess = performance.now();
         
    const batchSize = BATCH_SIZE;
   
    setProcessBatchWait(true)
 
    for (let i = 0; i < numbers.length; i += batchSize) {
     
       
      const batch = numbers.slice(i, i + batchSize);
      const batchResults = await processBatch(batch);
      setCorrectImeiData(prevData => [...prevData, ...batchResults]); // Append batch results to table
      await new Promise(resolve => setTimeout(resolve, 0)); // Yield to the event loop to prevent freezing
     

     
    }
    const endTimeProcess = performance.now();
   

    const timeElapsedProcess = (endTimeProcess - startTimeProcess).toFixed(2);
    setProcessTime(timeElapsedProcess);
    setProcessBatchWait(false);
   
  };

  // useEffect(()=>{
  //  if (tableEndRef.current) {
  //     tableEndRef.current.scrollIntoView({ behavior: 'smooth' });
  //   }

  // },[correctImeiData]);

  useEffect(() => {
      if (correctImeiData.length === 0) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else if (tableEndRef.current) {
        tableEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, [correctImeiData]);
 
  useEffect(() => {
   // if (correctData.length > 0) {
      setPleaseWait(false);
      processAllNumbers(correctData);
     // setCorrectImeiData(correctData);  // Update correctImeiData when correctData changes
   // }

  }, [correctData]);
  
 
 
 



  const processUploadedFile = async (selectedFile, correctData) => {
    const file = selectedFile;
    setFile(file);
  
    if (file) {        
      const fileType = file.type;
      if (fileType === 'text/csv') {    
  
        const formData = new FormData();
        formData.append('file', file);
        formData.append('user',decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email)
               
  
        try {
          const response = await fetch(APP_URL + 'bulkNotifyCopy.php', {
            method: 'POST',
            body: formData,
            headers: {
              'X-API-Key': decryptResponse(
                JSON.parse(localStorage.getItem("userSession")).data.payload,
                JSON.parse(localStorage.getItem("userSession")).data.transactionId
              ).token
            }
          });
  
          const result = await response.json();
       
  
          if (result.status==="success") {
            setError('');
            setCorrectData(correctData);
            localStorage.setItem("correctedDataNotify", JSON.stringify(correctData));
            updateNotificationCommandOnServer(localStorage.getItem("correctedDataNotify"));
          } else {
            alert(result.message);
            setError(result.message);
          }
        } catch (error) {
          setError('An error occurred while uploading the file.');
        }
      } else {
        setFile(null);
        setError('Only CSV files are allowed.');
      }
    }
  };
  




  const handleFileUpload = (event) => {
    event.preventDefault();

    setFile(null);
    setCsvContent([]);
     // resetting states
     setCorrectData([]);
     setCorrectImeiData([]);
    
     setNewBatch(true);
     setBatchComplete(false);
    
     setError([]);
     setFileName('');
     setFileSize('');
     setBatchFileName('');
     setProcessTime(0);
     setPleaseWait();
     setPendingBulkNotify(false);
     setProcessBatchWait(false);

     const selectedFile = event.target.files[0];
    const file = selectedFile
    setFile(file)
   
       
    setFileName(selectedFile.name);
   
    setFileSize(selectedFile.size);
    const reader = new FileReader();
    const startTime = performance.now();
    reader.onload = (e) => {
    const content = e.target.result;
    const validation = validateCsvContent(content);


      if (validation.isValid) {
        setCsvContent(content);
        setFile(selectedFile);
        setError('');
        parseCsv(content);

        setPreviewData({
          fileName: selectedFile.name,
          fileSize: selectedFile.size,
          correctData: validation.correctData,
        });
        setShowPreviewModal(true);
      } else {
        setError(validation.error);
        setIncorrectData(validation.incorrectData);
        setJsonContent(null);
        setShowDownloadButton(true);
      }
    };

    reader.readAsText(selectedFile);
  };



  const handlePreviewConfirm = () => {
    setShowPreviewModal(false);
    if (file && previewData) {
      processUploadedFile(file, previewData.correctData);
    }
  };


  const handleCancel = () => {
    
    setShowPreviewModal(false);
  };




  const validateCsvContent = (content) => {
    const lines = content.trim().split('\n').filter(line => line.trim());
    const incorrectData = [];
    const correctData = [];
    const firstCell = lines[0].split(',');

    if(firstCell[0].trim().toLowerCase() === "sno" && firstCell[1].trim().toLowerCase() === "name" && firstCell[2].trim().toLowerCase() === "imei1" && firstCell[3].trim().toLowerCase() === "amount" && firstCell[4].trim().toLowerCase() === "date" && firstCell[5].trim().toLowerCase() === "template") {

        for (let i = 1; i < lines.length; i++) {
            const cells = lines[i].split(',').map(cell => cell.trim());
            if(cells.length === 6) {
                const [sno, name, imei1, amount, date, template] = cells;
                let rowError = false;
                let incorrectFields = [];
                let errorMessages = [];

                if (!/^\d{15}$/.test(imei1.trim())) {
                    incorrectFields.push('IMEI');
                    errorMessages.push("Invalid IMEI (must be 15 digits)");
                    rowError = true;
                }

                if (!["Pre", "Post", "Due"].includes(template)) {
                    incorrectFields.push('Template');
                    errorMessages.push("Invalid template, expected values are 'Pre', 'Post', or 'Due'");
                    rowError = true;
                }

                if (!/^\d+(\.\d{1,2})?$/.test(amount) || amount.trim() === "") {
                    incorrectFields.push('Amount');
                    errorMessages.push("Invalid amount (must be a number with up to 2 decimal places)");
                    rowError = true;
                }

                // Validate Date format (DD/MM/YYYY)
                const dateParts = date.split('/');
                if (dateParts.length !== 3 || isNaN(Date.parse(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`))) {
                    incorrectFields.push('Date');
                    errorMessages.push("Invalid date format (expected DD/MM/YYYY)");
                    rowError = true;
                }

                if (rowError) {
                    incorrectData.push({
                        line: i + 1,
                        error: `Incorrect fields: ${incorrectFields.join(', ')}`,
                        data: cells.join(',') + `, Error Messages: ${errorMessages.join(', ')}`
                    });
                }

                if (!rowError) {
                    const formattedAmount = parseFloat(amount).toFixed(2);
                    const formatDate = `${dateParts[0]}/${dateParts[1]}/${dateParts[2]}`;

                    let myheader = '';
                   
                    let message = '';
                    switch (template) {
                        case 'Pre':
                            myheader = `Reminder: Your payment is due soon .`; 
                            message = `Dear ${name}, your EMI of ${formattedAmount} is due on ${formatDate}. Please maintain adequate account balance to avoid additional charges and impact on your credit score.`;
                            break;
                        case 'Post':
                           myheader = `Urgent Attention: Your payment is past due.`;
                            message = `Dear ${name}, An amount of ${formattedAmount} of your EMI and charges is overdue. Please pay immediately to avoid impact on credit score.`;
                            break;
                        case 'Due':
                            myheader = `Urgent Attention: Dear ${name}, Your payment is due on ${formatDate}.`;
                            message = `Your EMI of ${formattedAmount} is due on ${formatDate}. Please maintain adequate account balance to avoid additional charges and impact on your credit score.`;
                            break;
                    }

                    correctData.push({
                        sno,
                        name,
                        imei1,
                        amount,
                        date: formatDate,
                        template,
                        myheader,
                        message
                    });
                }
            } else {
                incorrectData.push({
                    line: i + 1,
                    error: "Invalid row, missing or extra columns",
                    data: cells.join(',')
                });
            }
        }
    } else {
        incorrectData.push({
            line: 1,
            error: "Invalid Headers",
            data: "headers not matched"
        });
    }

    if (incorrectData.length > 0) {
        handleDownloadIncorrectData(incorrectData);
        return {
            isValid: false,
            error: `CSV contains incorrect format data.`,
            incorrectData: incorrectData
        };
    } else if (correctData.length > 0) {
        return {
            isValid: true,
            correctData: correctData
        };
    }

    setPleaseWait(true);
    return { isValid: true };
};




 
 
  const updateNotificationCommandOnServer=async (imeilist)=>{
  //   const jsonArray = JSON.parse(imeilist);

  // // Step 2: Convert array to a comma-separated string
  // const imeilist1 = jsonArray.join(',');
  const data = JSON.parse(imeilist);

// Extract and join IMEIs
const imeilist1 = data.map(item => item.imei1).join(",");

 
    try{
      const response = await axios.put(APP_URL+"updateCommandOnServer.php",
      encryptPayload(  {'imeilist':imeilist1,
          'action':'notify',
           'user':decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).email
          
        }),
        {withCredentials: withCredentials,
          headers: {
          'Content-Type': 'application/json',
          'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload,JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
        }}
      )     
    }catch(error){
       /* continue regardless of error */
    }
  }

  const parseCsv = (content) => {
    const lines = content.split('\n').filter(line => line.trim());
    const data = lines.map(line => line.split(',').map(cell => cell.trim()));
    setJsonContent(JSON.stringify(data, null, 2));
  };

  const handleUploadClick = () => {
    resetComponent()
    fileInputRef.current.click();
  };

    const handleDownloadIncorrectData = (incorrectData) => {
    const csvContent = generateCsvContent(incorrectData);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    setDownloadUrl(url);
  };

 
  const generateCsvContent = (incorrectData) => {
    const lines = incorrectData.map(error => `${error.line},${error.data},${error.error}`);
    return 'Sno,Incorrect Data,Error Message\n' + lines.join('\n');
};
 
  
 
  const resetComponent = () => {
    setFileName('');
    setError('');
    setFile(null);
    setFileSize(0);
    setCsvContent('');
    setJsonContent(null);
    setIncorrectData([]);
    setDownloadUrl(null);
    setShowDownloadButton(false);
    setReadingTime(0);
    setIncorrectData([])
    setCorrectData([])
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset the file input
    }
  };
  const handleSingleImei=(event)=>{
    //alert(event.target.value)
    setSingleImei(event.target.value)  
  }
  const handleNotify = async (event) => {
    event.preventDefault();
    
    if (!selectedOption) {
      alert("Please select a template");
      return;
    }
  
    let message1 = "";
    let preview1 ="";
    let caseType = "";
  
    const today = moment();
    const formattedAmount = `₹ ${amount}`; // Adjust as needed
   
    const formatDate = ` ${date}`; // Adjust as needed

    
    // Format the due date
    const formattedTodayDate = moment().format('DD/MM/YYYY'); // Format today's date

      
  
    switch (parseInt(selectedOption)) {
      case 1:
        message1 = `Reminder: Your payment is due soon  Dear ${customerName}, your EMI of ${formattedAmount} is due on ${formatDate}. Please maintain adequate account balance to avoid additional charges and impact on your credit score.`;
        preview1 = `Reminder: Your payment is due soon \n\n Dear ${customerName}, your EMI of ${formattedAmount} is due on ${formatDate}. Please maintain adequate account balance to avoid additional charges and impact on your credit score.`;
        
        setMessage(message1); // Assuming setMessage is a function to store the message in state
        caseType = "Pre";
        break;
      case 2:
        message1 = ` Urgent Attention: Dear ${customerName}, Your payment is due on ${formattedTodayDate}. Your EMI of ${formattedAmount} is due on ${formattedTodayDate}. Please maintain adequate account balance to avoid additional charges and impact on credit score.`;
        preview1 = ` Urgent Attention: Dear ${customerName}, Your payment is due on ${formattedTodayDate}.\n\n Your EMI of ${formattedAmount} is due on ${formattedTodayDate}. Please maintain adequate account balance to avoid additional charges and impact on credit score.`;

        setMessage(message1);
        caseType = "Due";
        break;
      case 3:
        message1 = `Urgent Attention: Your payment is past due.Dear ${customerName}, An amount of ${formattedAmount} of your EMI and /or charges is overdue. Please pay immediately to avoid impact on credit score.`;
        preview1 = `Urgent Attention: Your payment is past due.\n\nDear ${customerName}, An amount of ${formattedAmount} of your EMI and /or charges is overdue. Please pay immediately to avoid impact on credit score.`;
        setMessage(message1);
        caseType = "Post";
        break;
    }
  
    const action = "notify";
  
    if (window.confirm('Notification Preview \n\n' + preview1) === true) {
      try {
        const response = await axios.post(APP_URL + 'locknotification.php',
          encryptPayload({
            "imei": singleImei,
            "action": action,
            "message": message1,
            caseType: caseType,
            'user': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload, JSON.parse(localStorage.getItem("userSession")).data.transactionId).email
          }),
          {
            withCredentials: withCredentials,
            headers: {
              'Content-Type': 'application/json',
              'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload, JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
            }
          });
        
          
        const decryptText = decryptResponse(response.data.payload, response.data.transactionId);
        if (decryptText.status === 'success') {
          alert("Enable Notification initiated  successfully.");
          
        } else if (decryptText.status !== 'success') {
          if (decryptText.message === "Authorization Failed.Invalid" || decryptText.message === "Authorization Failed") {
            localStorage.removeItem('loggedin');
            localStorage.removeItem('token');
            localStorage.removeItem('expiry');
            localStorage.removeItem('user');
            navigate("/");
          } else {
            alert(decryptText.message);
          }
        }
      } catch (error) {
        /* continue regardless of error */
      }
    } else {
      setSelectedOption(0);
      setSingleImei('');
    }
  };

  // const handleNotify = async (event) => {
  //   event.preventDefault();
    
  //   if (!selectedOption) {
  //     alert("Please select a template");
  //     return;
  //   }
  
  //   let message1 = "";
  
  //   const today = moment();
  //   const formattedAmount = `₹ ${amount}`; // Adjust as needed
  //   // const formatDate = ` ${date}`; // Adjust as needed
  //   // Convert date from YYYY-MM-DD to MM/DD/YY format
  //   // const [year, month, day] = date.split("-");
  //   // const formatDate = `${month}/${day}/${year}`; // MM/DD/YY format
  //   const formatDate = ` ${date}`; // Adjust as needed

    
  //   // Format the due date
  //   const formattedTodayDate = moment().format('DD/MM/YYYY'); // Format today's date

      
  
  //   switch (parseInt(selectedOption)) {
  //     case 1:
  //       message1 = `Reminder: Your payment is due soon \n\nDear ${customerName}, your EMI of ${formattedAmount} is due on ${formatDate}. Please maintain adequate account balance to avoid additional charges and impact on your credit score.`;
  //       setMessage(message1); // Assuming setMessage is a function to store the message in state
  //       break;
  //     case 2:
  //       message1 = ` Urgent Attention: Dear ${customerName}, Your payment is due on ${formattedTodayDate}.\n\nYour EMI of ${formattedAmount} is due on ${formattedTodayDate}. Please maintain adequate account balance to avoid additional charges and impact on credit score.`;
  //       setMessage(message1);
  //       break;
  //     case 3:
  //       message1 = `Urgent Attention: Your payment is past due. \n\n Dear ${customerName}, An amount of ${formattedAmount} of your EMI and /or charges is overdue. Please pay immediately to avoid impact on credit score.`;
  //       setMessage(message1);
  //       break;
  //   }
  
  //   const action = "notify";
  
  //   if (window.confirm('Notification Preview \n\n' + message1) === true) {
  //     try {
  //       const response = await axios.post(APP_URL + 'locknotification.php',
  //         encryptPayload({
  //           "imei": singleImei,
  //           "action": action,
  //           "message": message1,
  //           'user': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload, JSON.parse(localStorage.getItem("userSession")).data.transactionId).email
  //         }),
  //         {
  //           withCredentials: withCredentials,
  //           headers: {
  //             'Content-Type': 'application/json',
  //             'X-API-Key': decryptResponse(JSON.parse(localStorage.getItem("userSession")).data.payload, JSON.parse(localStorage.getItem("userSession")).data.transactionId).token
  //           }
  //         });
  
  //       const decryptText = decryptResponse(response.data.payload, response.data.transactionId);
  //       if (decryptText.status === 'success') {
  //         alert("Enable Notification initiated  successfully.");
  //       } else if (decryptText.status !== 'success') {
  //         if (decryptText.message === "Authorization Failed.Invalid" || decryptText.message === "Authorization Failed") {
  //           localStorage.removeItem('loggedin');
  //           localStorage.removeItem('token');
  //           localStorage.removeItem('expiry');
  //           localStorage.removeItem('user');
  //           navigate("/");
  //         } else {
  //           alert(decryptText.message);
  //         }
  //       }
  //     } catch (error) {
  //       /* continue regardless of error */
  //     }
  //   } else {
  //     setSelectedOption(0);
  //     setSingleImei('');
  //   }
  // };
 
  const hidePendingBatch=()=>{
    setPendingBulkNotify(false)
  }

  const handleProcessBatch=()=>{
    convertToCSV()

    setNewBatch(false)
   
    const correctData = JSON.parse(localStorage.getItem('correctedDataNotify'));
    //setCorrectImeiData(prevData => [...prevData])

 
    const lastimei = JSON.parse(localStorage.getItem('notifyBatchStatus')).lastimei
   
    const fileName = JSON.parse(localStorage.getItem('notifyBatchStatus')).batchfilename
    setBatchFileName(fileName);
    setFileName(fileName)

   
    const index = correctData.findIndex(entry => entry.imei1 === lastimei)
   

    if (index !== -1) {

      // Step 1: Download already processed data
      // const alreadyProcessed = correctData.slice(0, index + 1);

      // downloadCSVFromData(alreadyProcessed, fileName);
      // Step 2: Set the remaining data for processing
      const unFinishedCorrectedData = correctData.slice(index + 1);
      setCorrectData(unFinishedCorrectedData)
      
      // downloadCSVFromData(unFinishedCorrectedData, fileName);


      

      //processAllNumbers(unFinishedCorrectedData)

    
   

  


   } else {
      alert("This batch cannot be processed, please start a new batch or cancel this batch")
    }
  }

  

  const downloadCSVFromData = (data, fileName) => {
  if (!data || data.length === 0) {
    alert("No data to download.");
    return;
  }

  const headers = ['S.No', 'Name', 'IMEI1', 'Amount', 'Date', 'Template', 'My Header', 'Notification', 'Device Available'];
  
  const rows = data.map((item, index) => [
    index + 1,
    item.name || '',
    item.imei || item.imei1 || '',
    item.amount || '',
    item.date || '',
    item.template || '',
    `"${(item.myheader || '').replace(/"/g, '""')}"`,
    `"${(item.nmessage || '').replace(/"/g, '""')}"`,
    item.message || ''
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', fileName.replace('.csv', '_processed.csv'));
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  const handleNewBatch=()=>{
    setNewBatch(true) 
    hidePendingBatch()
   
  }
  const handleTemplate=(e)=>{
   
    setSelectedOption(e.target.value)

  }



// Function to convert table data into CSV format

const convertToCSV = () => {
  const rows = [
    // Adding the header row
    ['S.No', 'Name', 'IMEI1', 'Amount', 'Date', 'Template', 'My Header', 'Notification', 'Device Available'],
    ...correctImeiData.map((item, index) => [
      index + 1,
      item.name,
      item.imei,
      item.amount,
      item.date,
      item.template,
      `"${item.myheader}"`, 
      `"${String(item.nmessage)}"`,  // Wrapping nmessage in double quotes to prevent breaking
      item.message,
    ]),
  ];

  console.log(rows);

  // Convert to CSV string
  const csvContent = rows
    .map(row => row.join(','))  // Joining values with a comma
    .join('\n');  // New line for each row

  // Trigger download
  const link = document.createElement('a');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', fileName); // Ensure fileName is set properly
  link.click();
};


//const isDataAvailable = correctImeiData && correctImeiData.length > 0;







  return (
    <div className="container-fluid">
      <div className="row">
      <div className="col-md-12 grid-margin transparent">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Notify: Single</h4>
              <form className="forms-sample" onSubmit={handleNotify}>
      <div className="form-group row">
        <div className="col-sm-6">
          <p>Name:</p>
          <input
            type="text"
            placeholder="Enter Customer Name"
            className="form-control input-sm"
            required
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
          />
        </div>
        <div className="col-sm-6">
          <p>IMEI</p>
          <input
            type="number"
            min="100000000000000"
            max="999999999999999"
            placeholder="Enter IMEI of device"
            className="form-control input-sm"
            required
            onInput={handleSingleImei}
          />
          <p className="p-2">Please provide  15 digit IMEI number</p>
        </div>
      </div>

     
     

      <div className="form-group row">
        
        <div className="col-sm-6">
        <p>Choose A Notification Template</p>
          <select
            className="form-control "
            onChange={handleTemplate}
            required
            value={selectedOption}
          >
            <option value="">----Choose a template----</option>
            <option value="1">Pre Due Notification</option>
            <option value="2">Due Date Notification</option>
            <option value="3">Post Due Date Notification</option>
          </select>
          <p className="p-2">Please select a notification template</p>
        </div>
       
        <div className="col-sm-3">
  <p>Amount:</p>
  <input
    type="text"
    placeholder="Enter Amount"
    className="form-control input-sm"
    required
    value={amount}
    onChange={(e) => {
      const value = e.target.value;
      const regex = /^\d*\.?\d{0,2}$/;

      if (regex.test(value) || value === "") {
        setAmount(value);
      }
    }}
    onBlur={() => {
      if (amount) {
        setAmount(parseFloat(amount).toFixed(2)); // Ensure two decimal places on blur
      }
    }}
  />
</div>

<div className="col-sm-3">
  <p>Date:</p>
  {/* <input
    type="date"
    placeholder="Enter Date"
    className="form-control input-sm"
    required
    value={date}
    onChange={(e) => setDate(e.target.value)}
    disabled={selectedOption === "2"}
    min={selectedOption === "1" ? new Date().toISOString().split("T")[0] : ""}
    max={selectedOption === "3" ? new Date().toISOString().split("T")[0] : ""}
/> */}
<input
    type="date"
    placeholder="Enter Date"
    className="form-control input-sm"
    required
    value={date ? date.split("/").reverse().join("-") : ""}
    onChange={(e) => {
        const selectedDate = e.target.value; // YYYY-MM-DD
        if (selectedDate) {
            const [year, month, day] = selectedDate.split("-");
            setDate(`${day}/${month}/${year}`); // Correctly format to DD/MM/YYYY
        }
    }}
    disabled={selectedOption === "2"}
    min={selectedOption === "1" ? new Date().toISOString().split("T")[0] : ""}
    max={selectedOption === "3" ? new Date().toISOString().split("T")[0] : ""}
/>




</div>
      </div>
      <div className="submit-buttons">
        <button type="submit" className="btn btn-success me-2 btn-sm text-white">
          Submit
        </button>
      </div>
    </form>
            </div>
          </div>
        </div>
        <div className="col-md-12 grid-margin transparent">

         { pendingBulkNotify && (
          <div className='card' style={{marginBottom:'30px'}}>
            <div className="card-body">          
              <h4 className="card-title">Incomplete Batch Available</h4>
              <hr></hr>
              <p>Filename : {batchfilename}</p>
              <p>Last Processed Imei :{lastimei}</p>
              <hr></hr>
              <p className='text-center text-primary' >Process  / Start New Batch </p>
              <p className='text-center'>
                <button className="btn btn-success btn-sm text-white marginLeftRight" onClick={handleProcessBatch}>Process</button> <span></span>
               
                <button className="btn btn-primary btn-sm text-white marginLeftRight" onClick={handleNewBatch}>New Batch</button>
             
              </p>
            </div>

          </div>

          )}

          {newBatch &&(<div className="card">
            <div className="card-body">
              <h4 className="card-title">IMEI Notify: Batch Upload</h4>
              <form className="forms-sample" >
                <div className="form-group row">
                <div className="col-sm-6 ">

 <input
                    type="file"
                    className="file-upload-default"
                    id="fileInput"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileUpload}
                  />
              
                  <div className="input-group">                    
                    <input
                      type="text"
                      className="form-control input-sm file-upload-info"
                      disabled
                      placeholder="Upload CSV"
                      value={fileName}
                    />
                    <span className="input-group-append">
                      <button
                        className="file-upload-browse btn btn-primary btn-sm"
                        type="button"
                        onClick={handleUploadClick}
                      >
                        Select File
                      </button>
                    </span>
                  </div>

                </div>
                 
                 
                </div>
                {error && <p className="text-danger">{error}</p>}
                {file && (
                  <p>
                    File Details : {file.name} ({(fileSize / 1024).toFixed(2)} KB)
                    {readingTime > 0 && `<br/> - Reading time: ${readingTime} ms`}
                  </p>
                )}
               {incorrectData.length > 0 && (
                  <div className="invalid-imei-container">
                    <div className="row d d-flex ">
                      <h4 className="col-md-4 mx-3">Invalid IMEI:</h4>
                      {downloadUrl && (
                        <a
                          className=""
                          href={downloadUrl}
                          download="incorrect_data.csv"
                        >
                          Click here to download
                        </a>
                      )}
                    </div>
                    <p>
                      File size: {(fileSize / 1024).toFixed(2)} KB
                      <span className="mx-2">|</span>
                      Reading time: {readingTime} ms
                    </p>

                   
               
                  </div>
                )}
             
              </form>
            </div>
          </div>)
       }



        </div>
        <div className="row">
         <div className="col-md-12 grid-margin transparent">
         {pleasWait && (
          <div className="loading-message">
              <div className="spinner"></div>
            <p>Please wait while we evaluate this batch. You are requested not to refresh/reload/or navigate </p>
           
           
          </div>
        )}


      {processBatchWait && (
          <div className="loading-message">
           
            <div className="spinner"></div>
            <p >Please Wait while we are executing this batch.You are requested not to refresh/reload/or navigate .</p>
           
         
          </div>
        )}

       
        {batchComplete &&(
          <div>
            <br></br>
            <p>Process Time : {processTime} ms</p>
          </div>
        )}
       
         
       
         <p style={{backgroundColor: 'white',padding:5}}> Batch Summary - Total {correctData.length + incorrectData.length} ||   <span style={{color:'green'}}>Valid IMEI :{correctData.length} </span>  ||  <span style={{color:'red'}}>Invalid IMEI :{incorrectData.length} </span> || <span style={{color:'green'}}> Found {correctImeiData.filter((item)=>{return item.message==="found"}).length}</span> || <span style={{color:'red'}}> Not Found {correctImeiData.filter((item)=>{return item.message==="not found"}).length}</span></p>
        
         <div className="row mb-3" style={{ marginBottom: "20px", justifyContent: "flex-end" }}>
        <button
          className="btn btn-info btn-sm text-white"
          onClick={convertToCSV}
          disabled={correctImeiData.length === 0} // Disable if there's no data
          style={{ marginRight: "10px", width: "auto" }}
        >
          Download CSV
        </button>
      </div>
        
        
        
        
        
        
       
         <div style={{height:'350px',overflow:'scroll'}}>
         <table className="table table-bordered mt-3">
  <thead>
    <tr>
      <th>S.No</th>
      <th>Name</th>
      <th>IMEI</th>
      <th>Amount</th>
      <th>Date</th>
      <th>Template</th>
      <th>Header</th>
      <th>Notification</th>
      <th>Device Available</th>
    </tr>
  </thead>
  <tbody>
    {correctImeiData.map((item, index) => (
      <tr key={index}  style={{ color: item.message === "found" ? 'green' : 'red' }}>
        <td>{index+1}</td>
        <td>{item.name}</td>
        <td>{item.imei}</td>
        <td>{item.amount}</td>
        <td>{item.date}</td>
        <td>{item.template}</td>
        <td>{item.myheader}</td>
        <td>{item.nmessage}</td> 
        <td>{item.message}</td> {/* Display message here */}
      </tr>
    ))}
    <tr ref={tableEndRef}></tr>
  </tbody>
</table>


          </div>

         
         </div>
        </div>
        <div className='row'>

     

        <Modal show={showPreviewModal} onHide={() => {}} backdrop="static" >
  <Modal.Header closeButton={false}>
    <Modal.Title>File Preview</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p><strong>File Name:</strong> {previewData?.fileName}</p>
    <p><strong>File Size:</strong> {previewData?.fileSize} bytes</p>
    <h3>Data Preview:</h3>
    <div className="table-responsive" style={{maxHeight:'300px'}}>
      <table className="table table-striped " border={1}>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>IMEI</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Template</th>
            <th>Header</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {previewData?.correctData?.map((item, index) => (
            <tr key={index}>
              <td>{item.sno}</td>
              <td>{item.name}</td>
              <td>{item.imei1}</td>
              <td>{item.amount}</td>
              <td>{item.date}</td>
              <td>{item.template}</td>
              <td>{item.myheader}</td>
              <td>{item.message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
    <Button variant="primary" onClick={handlePreviewConfirm}>Submit</Button>
  </Modal.Footer>
</Modal>

    
        </div>
      </div>
    </div>
  );
};

EnableNotification.displayName = "EnableNotification"
export default EnableNotification;